<template>
<div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Aprobación de Millas Navegadas</h4>        
                <hr>
                <p v-if=" (cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO') "> Aprobación de las Millas Navegadas en las CC.PP. </p>
                <p v-else> Aprobación de Millas Navegadas en las CC.PP. {{ cDtsUser.name_port | capitalize }}</p>
            </div>
        </div>
        <h6>Datos Generales</h6>
        <hr>
        
        <div class="form-row d-print-none">
            <div class="input-group mb-3 col-md-8 offset-md-2">
        
                <select class="form-control" name="year_ordop_a" id="year_ordop_a" v-model="year_select_a">
                    <option v-for="ya in years" :key="ya.c" :value="ya.c">{{ ya.c }}</option>
                </select>
                <select class="form-control" v-if="(cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO')" name="capitania_anexo" id="capitania_anexo" v-model="capitania_anexo" >
                    <option v-for="cpa in ports" :key=cpa.id :value="cpa">{{ cpa.name_port }}</option>
                </select>
                <div class="input-group-prepend" v-else>
                    <span class="input-group-text" id="">{{cDtsUser.name_port}}</span>
                </div>                
                <div class="input-group-append">
                    <button class="btn btn-outline-success" :disabled="animate_button" @click="mCallOrdops">
                        <font-awesome-icon icon="sync-alt" :spin="animate_button"/>
                    </button>            
                </div>
            </div>            
        </div>

        

        <h6>Detalles ORDOP</h6>
        <hr>
        <div class="form-row">
                        <transition name="fade" mode="out-in">
                            <div class="form-group col-12 col-md-6 offset-md-3" v-if="ordops_init_app.length > 0">
                                <label for="ordop_init">Ordop Inicial</label>
                                <select class="form-control" name="ordop_ia" id="ordop_ia" v-model="ordop_master_app" @change="callPersonsOrdopApp">
                                    <option v-for="oi in ordops_init_app" :key="oi.id" :value="oi">{{ oi.detail }}</option>
                                </select>
                            </div>
                        </transition>
                    </div>
        
        
        <h6>Tipo Anexo</h6>
        <hr>
            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-millas" role="tab" aria-controls="nav-profile" aria-selected="false"> <font-awesome-icon icon="route" /> Millas Navegadas </a>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <br>            

                <div class="tab-pane fade show active"  id="nav-millas" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>Registro de las Millas Navegadas</h6>
                    <hr>
                    
                    <label for="bandera_embarcacion">Listado de Personal que participo en la ORDOP<span class="required-text">*</span></label>
                            <div class="table-responsive col-12">
                                <table class="table table-sm" v-if="millas_ordop_person_app.length > 0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Grado y Nombre</th>
                                            <th>Cargo o Rol</th>
                                            <th>Millas Navegadas</th>
                                            <th>Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pso, index) in millas_ordop_person_app" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td>                    
                                                <div v-if="pso.is_verify==='N'">
                                                    <div v-if="!pso.is_edit"> {{ pso.millas }} </div>                            
                                                    <input type="number" class="form-control col-md-8" v-else v-model="millas_temp_app.millas" min="0" />
                                                </div>
                                                <div v-else> {{ pso.millas }} </div>
                                            </td>
                                            <td>
                                                <div class="input-group mb-3" v-if="pso.is_verify==='N'">
                                                    <div class="input-group-append" v-if="!pso.is_edit">
                                                        <button class="btn btn-outline-primary" type="button" @click="mEditPersonMilla(index)" ><font-awesome-icon icon="edit" /></button>
                                                    </div>
                                                
                                                    <div class="input-group-append" v-else>
                                                        <button class="btn btn-outline-success" type="button" @click="mSavePersonMilla(index)"><font-awesome-icon icon="save" /></button>
                                                        <button class="btn btn-outline-danger" type="button" @click="mCancelEditPersonMilla(index)"><font-awesome-icon icon="times-circle" /></button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    <br><br>
                    <button class="btn btn-success col-12 col-md-2 offset-md-5" v-if="millas_ordop_person_app.length > 0 && millas_ordop_person_app[0].is_verify==='N'" @click="mUploadMillasApp"><font-awesome-icon icon="sync-alt" size="2x" /></button>

                </div>
                <!-- end millas navegadas -->

            </div>
        
        </div>
        <!-- <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest" ></modal-loading> -->
</div>  
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'millas-ordop',
    mounted(){
        this.mChargeInit();
        this.mVerifyCaptain();
    },
    data(){
        return{
            idModalL:'UploadPhotoOrdop',
            modalLoadTitle:'Subiendo',
            sendRequest:true,
            years:[],
            ports:[],
            year_select_a:0,
            capitania_anexo:{id:0},
            ordops_init_app:[],
            animate_button:false,
            ordop_master_app:{id:0},
            millas_ordop_person_app:[],
            millas_temp_app:{id_person:0, indice:0, millas:0.0}
        }
    },
    methods:{
        mVerifyCaptain(){
            if(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && this.cDtsUser.roleAssign !== 'FINANCIERO'){
                this.capitania_anexo.id=0;
            }else{                
                this.capitania_anexo.id = this.cDtsUser.portId;
                this.capitania_anexo.name_port = this.cDtsUser.name_port;
            }
             
        },
        async mChargeInit(){
            // console.log(this.photo_result.image)
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.ports=cp.data;
            let ya=new Date();
            
            this.year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<=this.year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
        },
        mChangeGeneral(){
            this.ordops_init_app=[];
            this.ordops_result=[];
        },
        async mCallOrdops(){
            // verificar la categoria de 
            // limpiamos ambos resultados de las ordops
            this.animate_button=true;
            this.ordops_init_app=[];
            this.ordops_result=[];
            let idCap=(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && this.cDtsUser.roleAssign !== 'FINANCIERO') ? this.capitania_anexo.id : this.cDtsUser.portId;
            console.log(`${this.year_select_a} y ${idCap}`);
            if(this.year_select_a > 0 && idCap > 0 ){
                // obtenemos la ordop inicial
                let rsoi=await axios.get(`getOrdopsAnexo/${this.year_select_a}/${idCap}?api_token=${Vue.auth.getToken()}`);
                // console.log(rsoi);
                let dtsTemp=rsoi.data;
                this.animate_button=false;
                if(dtsTemp.length > 0){
                    this.ordops_init_app=dtsTemp;
                }else{
                    toastr.warning('No existe Ordops registradas', 'Informacion');
                }
                
            }else{
                // no cambiamos el resultado
                toastr.warning('Verifique que los campos de <b>Datos Generales</b> esten correctos', 'Advertencia');
            }           
        },
        async mUploadMillasApp(){
            
                let message = {
                        title: 'Millas Navegadas',
                        body: `¿Desea Aprobar las Millas Navegadas de la ORDOP <b>${this.ordop_master_app.detail}</b> de la gestion <b>${this.year_select_a}</b> de la capitania <b>${this.capitania_anexo.name_port}</b>? <br><b>Nota:</b> una vez enviado los datos no se podra actualizar ni modificar las millas Navegadas`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            // this.mShowModalUP(this.idModalL);
                            try {
                                let dtsMillas={
                                    id:this.ordop_master_app.id,
                                    persons:JSON.stringify(this.millas_ordop_person_app)
                                }

                                // console.log(dtsLocation);
                                let fd= await axios.post(`upMillasOrdop/ua?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsMillas));
                                    console.log(fd);
                                if(fd.data.status){
                                    toastr.success(fd.data.respuesta, 'Exito');

                                    this.callPersonsOrdopApp(); 
                                }else{
                                    toastr.error(fd.data.respuesta, 'Error');
                                }                                                        

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso de registro', 'Error MN-01')
                                    // this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        // this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo las millas de la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
        },
        async callPersonsOrdopApp(){
            // aqui seleccionamos la ordop para incluir a mas personas
            this.millas_ordop_person_app=[];
            console.log('llamando a las personas de las ordops');
            // let data = this.ordop_select_persons     
            // aqui llamar los datos de las personas registradas
            let persons=await axios.get(`getOrdopPersonsFinish/${this.ordop_master_app.id}?api_token=${Vue.auth.getToken()}`);
            console.log(persons);
            persons.data.forEach(el=>{
                if(el.is_save==='S'){
                    let aux_per_old={
                        complete:el.complete,
                        charge:el.charge,
                        id_person:el.id_person,
                        is_save:el.is_save,
                        is_verify:el.is_verify,
                        is_edit:false,
                        millas:el.millas_navigate,
                    };
                    this.millas_ordop_person_app.push(aux_per_old);
                }
                
            });
            // this.process_ordop_person.persons_old=persons.data;
        },
        mVerifyCampEditPersonMilla(){
            for(let key in this.millas_ordop_person_app){
                if( this.millas_ordop_person_app[key].is_edit ){
                     this.millas_ordop_person_app[key].is_edit=false;
                     this.millas_temp_app={};
                }
            }
        },
        mEditPersonMilla(index){
            // crear un temporal de edicion al momento de editar el temporal se debe llenar con los datos anteriores si se acepta la edicion se guarda y reemplaza, NO se mantiene el valor y se elimina el temporal, crear un id o key en cada registro dado que el codigo otros reeemplazara donde sea.
            // verificamos que no haya otro campo en edicion
            this.mVerifyCampEditPersonMilla();            
            this.millas_temp_app={
                id_person:this.millas_ordop_person_app[index].id_person,
                millas:this.millas_ordop_person_app[index].millas,
                indice:index
            }
            this.millas_ordop_person_app[index].is_edit=true;            
            
        },
        mSavePersonMilla(index){            
            // console.log(`terminando de editar el item ${index}`);
            if(this.millas_temp_app.millas >-1){

                if(this.millas_temp_app.indice===index){
                    this.millas_ordop_person_app[index].millas=this.millas_temp_app.millas;
                    this.millas_ordop_person_app[index].is_edit=false;
                    this.millas_temp_app={};
                    // this.mOrderListNews();
                }else{
                    toastr.warning(`Verifique la fila editada ${index+1}`);
                }
            }else{
                toastr.warning("Indique un valor mayor a -1 para su registro", "Millas navegadas");
            }
        },
        mCancelEditPersonMilla(index){
            this.millas_ordop_person_app[index].is_edit=false;
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
    },
    computed:{
        cVerifyButtonSend(){
            let idCap=(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && this.cDtsUser.roleAssign !== 'FINANCIERO') ? this.capitania_anexo.id : this.cDtsUser.portId;
            if(this.year_select_a > 0 && this.capitania_anexo.id > 0 && this.ordop_master_app.id > 0 && this.ordop_result_select.id > 0){
                return true;
            }else{
                return false;
            }
        },
        cVerifyButtonPhoto(){            
            if(this.year_select_a > 0 && this.capitania_anexo.id > 0 && this.ordop_master_app.id > 0 && this.ordop_result_select.id > 0 && this.hasImage){
                return true;
            }else{
                return false;
            }
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>

<style>
#imageOrdop img{
    width: 250px;
}
#fileInput {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopApproveMilla.vue